import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faAsterisk,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InviteStudent.css";
import GetAdminService from "../../../services/admin/GetAdminService";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";

const InviteStudent = ({ setOpenInviteStudent, schoolId }) => {
    const [emailError, setEmailError] = useState(true);
  const [email, setEmail] = useState();
  const counselorNameRef = useRef();
  const timeoutRef = useRef();
  const [showCounselorNameContainer, setShowCounselorNameContainer] = useState(
    false
  );
  const [counselorNameList, setCounselorNameList] = useState();
  const [counselorName, setCounselorName] = useState();
  const [counselorNameLoading, setCounselorNameLoading] = useState(false);
  const [counselorId, setCounselorId] = useState();
  const getCounselorsList = (value, role, school) => {
    setCounselorNameLoading(true);
    GetAdminService.getCounselorsList(value, role, school)
      .then((data) => {
        setCounselorNameList(data?.data?.result);
        setCounselorNameLoading(false);
        setShowCounselorNameContainer(true);
      })
      .catch((error) => {
        setCounselorNameLoading(false);
      });
  };

  const sendEmail = () => {
    let obj = {
    "email":email,
    "school":schoolId,
    "role":"student",
    }
    if(obj.role == "student"){
        obj.counselor= counselorId;
    }
    GetAdminService.sendCounselorEmail(obj)
    .then((data) => {
      swal({
        title: "Successfully",
        text: "Email send successfully",
        icon: "success",
        dangerMode: true,
        buttons: {
          ok: true,
        },
        closeOnClickOutside: true,
      });
    })
    .catch((error) => {
      swal({
        title: "Oops!!",
        text: error?.response?.data?.message,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true,
        },
        closeOnClickOutside: true
    })
    });
    setEmailError(true);
    setEmail("");
    setCounselorName("");
  }

  const handleCounselorName = () => {
    clearTimeout(timeoutRef.current);
    setCounselorName(counselorNameRef.current.value);
    if (!counselorNameRef.current.value) {
      setShowCounselorNameContainer(false);
      setCounselorNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getCounselorsList(
          counselorNameRef.current.value,
          "counselor",
          schoolId
        );
      }, 1000);
    }
  };

  const handleSelectedCounselorName = (item) => {
    setCounselorNameList([item]);
    setShowCounselorNameContainer(false);
    setCounselorName(item?.name);
    setCounselorId(item?.id)
  };

  const handleEmail=(e)=>{
    setEmail(e.target.value.toLowerCase())
    if(e.target.value.match("[a-z0-9]+@[a-z]+\.[a-z]{2,3}"))
    setEmailError(false)
    else {setEmailError(true);}
  }

  return (
    <Fragment>
      <div className="goal-full-container">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ fontSize: "18px" }}>Invite Student</p>
          <FontAwesomeIcon
            icon={faTimes}
            style={{ opacity: "0.2", cursor: "pointer" }}
            onClick={() => setOpenInviteStudent(false)}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <div style={{ position: "relative" }}>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <input
                ref={counselorNameRef}
                type="text"
                style={{ width: "85%", padding: "3px" }}
                placeholder="Type the counselor name"
                value={counselorName}
                onChange={handleCounselorName}
                autoComplete="off"
              />
              <FontAwesomeIcon
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  right: "75px",
                }}
                icon={faAsterisk}
                color="red"
              />
            </div>
            {showCounselorNameContainer && (
              <div
                style={{ display: "flex", position: "absolute", zIndex: "2" }}
              >
                <ul
                  className="admin-school-name-list"
                >
                  {counselorNameLoading && <CustomLoader />}
                  {counselorNameList?.length > 0 &&
                    counselorNameList.map((item, index) => (
                      <li
                        onClick={() => handleSelectedCounselorName(item)}
                        key={index}
                        className="flex admin-school-list cursor"
                      >
                        <span>{item.name}</span>
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
          <div>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "400",
                marginTop: "15px",
                borderBottom: "1px solid #e5e5e5",
              }}
            >
              Contact
            </p>
            <div>
              <div
                className="flex"
                style={{
                  marginTop: "15px",
                  justifyContent: "space-between",
                  position: "relative",
                }}
              >
                <input
                  type="email"
                  style={{ width: "85%", padding: "3px" }}
                  placeholder="Email"
                  value={email}
                  onChange={handleEmail}
                />
                <FontAwesomeIcon
                  style={{
                    fontSize: "12px",
                    position: "absolute",
                    right: "75px",
                  }}
                  icon={faAsterisk}
                  color="red"
                />
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={sendEmail}
          disabled={!counselorName ||  emailError}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "30px",
            position: "absolute",
            right: "30px",
            backgroundColor: emailError ? "#337ab7" : "#009900",
            outline: "none",
            border: "none",
            color: "white",
            padding: "5px 15px",
            marginTop: "15px",
            borderRadius: "3px",
          }}
        >
          <FontAwesomeIcon
            icon={faPaperPlane}
            color="white"
            style={{
              cursor: "pointer",
              marginRight: "5px",
              marginTop: "3px",
            }}
          />
          Invite
        </button>
      </div>
    </Fragment>
  );
};
export default InviteStudent;
